import { Component, OnInit, Injectable } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { DataService } from '../../services/data/data.service';
import { ClaimDetails, Claimant } from '../../models/claimant';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-complete',
  templateUrl: './complete.html',
  styleUrls: ['./complete.css'],
  imports: [DatePipe], // Add this using the DatePipe Directive in the template
})

  @Injectable({
    providedIn: 'root' // Add this line for LocalStorageService
  })

export class Complete implements OnInit {
  claimant: Claimant;
  cd: ClaimDetails;

  constructor(
    private storage: LocalStorageService,
    private dataService: DataService,

  ) { }

  ngOnInit() {
    this.claimant = this.storage.retrieve('claimant');
    this.cd = this.storage.retrieve('cd');
    this.dataService.getData();
  }
}
